"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeGetClipOverlay = exports.getClipOverlay = void 0;
const getClipOverlay = (overlays, name) => {
    const overlay = overlays.find(o => o.name === name);
    if (!overlay) {
        throw new Error("Clip configuration seems invalid or out-of-date");
    }
    return overlay;
};
exports.getClipOverlay = getClipOverlay;
const safeGetClipOverlay = (overlays, name) => {
    try {
        return (0, exports.getClipOverlay)(overlays, name);
    }
    catch (ex) {
        return {};
    }
};
exports.safeGetClipOverlay = safeGetClipOverlay;
//# sourceMappingURL=clip-template.js.map